import { Component } from "@angular/core";
import { PayGradeBenefitsModel } from "../models/pay-grade-benefits.model";
import { PayGradeBenefitsService } from "../services/pay-grade-benefits.service";
import { LoggedInUserService } from "../../services/common/logged-in-user.service";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { CommonModule, DecimalPipe } from "@angular/common";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { FormArray, FormControl, FormGroup, ReactiveFormsModule,} from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";

@Component({
  selector: "pay-grade-benefits",
  templateUrl: "./pay-grade-benefits.component.html",  
  standalone: true,  
  imports: [CommonModule, MatProgressSpinnerModule, MatTableModule, ReactiveFormsModule, MatFormFieldModule],
  providers: [DecimalPipe],
})
export class PayGradeBenefitsComponent {

  isLoading: boolean = false;
  dataSource: MatTableDataSource<PayGradeBenefitsModel>
  information: string = "";
  displayedColumns: string[] = ['psg', 'benefit1', 'benefit2', 'benefit3', 'benefit4', 'benefit5', 'benefit6', 'benefit7']
  data: PayGradeBenefitsModel[] = [];
  headerNames: string[] = [];
  
  formGroup: FormGroup = new FormGroup({
    benefit1: new FormArray([]),
    benefit2: new FormArray([]),
    benefit3: new FormArray([]),
    benefit4: new FormArray([]),
    benefit5: new FormArray([]),
    benefit6: new FormArray([]),
    benefit7: new FormArray([]),
  });

  constructor(
    private payGradeBenefitsService: PayGradeBenefitsService,    
    private userService: LoggedInUserService
  ) {}

  ngOnInit(): void {
    this.userService.currentUser$.subscribe(data => {
      if(data != null && data.adminRight){
        this.getPayGradeBenefits();
        this.information = "";
      }
      else if(data != null && !data.adminRight){
        this.information = "You are not authorized to view this page.";
      }
    })    
  }

  getPayGradeBenefits() {
    this.getBenefitCodes()
    this.isLoading = true;
    this.payGradeBenefitsService.getPayGradeBenefit().subscribe((data) => {
      this.data = data;
      this.isLoading = false;
      this.dataSource = new MatTableDataSource<PayGradeBenefitsModel>(data);
      this.loadFormArray();
    });
  }

  getBenefitCodes(){
    this.payGradeBenefitsService.getBenefitCodes().subscribe(data => {
      this.headerNames = data.map(item => item.description);
    });
  }

  submit(){    
    const payGradeBenefitsArray: PayGradeBenefitsModel[] = this.data.map((item, index) => {
      return {
      ...item,
      benefit1: this.formGroup.value.benefit1[index],
      benefit2: this.formGroup.value.benefit2[index],
      benefit3: this.formGroup.value.benefit3[index],
      benefit4: this.formGroup.value.benefit4[index],
      benefit5: this.formGroup.value.benefit5[index],
      benefit6: this.formGroup.value.benefit6[index],
      benefit7: this.formGroup.value.benefit7[index],
      };
    });

    this.payGradeBenefitsService.updatePayGradeBenefit(payGradeBenefitsArray).subscribe({
      next: (result) => {
        if (result.isSuccess) {
          this.information = "Records successfully updated.";
        } else {
          this.information = result.error.description;
        }
      },
      error: (err) => {
        console.error('Error updating Pay Grade Benefits:', err);
        this.information = 'An error occurred while updating the Pay Grade Benefits.';
      }
    });    
  }

  loadFormArray() {
    const benefits = ['benefit1', 'benefit2', 'benefit3', 'benefit4', 'benefit5', 'benefit6', 'benefit7'];

    benefits.forEach(benefit => {
      const formArray: FormArray = <FormArray>this.formGroup.get(benefit);
      this.data.forEach(item => {
        formArray.push(new FormControl(item[benefit]));
      });
    });
  }
}
